export const SET_FORMS = 'SET_FORMS';

export function setForms (forms) {
    return { type: SET_FORMS, forms}
}
